import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=1af20276&scoped=true&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"
import style0 from "./Show.vue?vue&type=style&index=0&id=1af20276&prod&lang=css&"
import style1 from "./Show.vue?vue&type=style&index=1&id=1af20276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af20276",
  null
  
)

export default component.exports